import InvoiceEvaluatorBaseItem from "../Domain/InvoiceEvaluatorBaseItem.js";
import AuthService from "./authService.js";
import SearchParams from "../Elements/SearchParams";
import InvoiceEvaluatorSearchParams from "../Contents/Operations/PaymentExport/AllExport/InvoiceEvaluatorSearchParams";

export default class InvoiceEvaluatorBaseService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();

    let url = "/api/InvoiceEvaluator/GetBySearchParams/?";

    const searchParams = new SearchParams(searchItem, InvoiceEvaluatorSearchParams, orderById, orderDir, pageNumber, numberOfElements, "base");

    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    url += `&clearCache=${clearCache}`;
    return authService.CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    if (itemlist !== null) {
      return itemlist.map((item) => new InvoiceEvaluatorBaseItem(item));
    }

    return [];
  }

  static IsNewPaymentRequestButtonEnabled(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/InvoiceEvaluator/IsNewPaymentRequestButtonEnabledAsync/${id}`);
  }

  static IsNewAdvancePaymentButtonEnabled(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/InvoiceEvaluator/IsNewAdvancePaymentButtonEnabledAsync/${id}`);
  }
}
